import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useGetCustomerQuery } from 'services/customers'
import useGlobalLoader from 'utils/custom-hooks/useGlobalLoader'
import VehicleGrid from './VehicleGrid'
import { useCustomerHeader } from '../account/utils'

const CustomerVehicles = () => {
  const { id: customerId } = useParams()
  const { data: customerData, isLoading } = useGetCustomerQuery({ customerId }, { skip: !customerId })
  const rows = customerData?.vehicles?.map((veh, i) => ({
    ...veh,
    id: i,
  }))

  useCustomerHeader(customerData)
  useGlobalLoader(isLoading)

  if (isLoading) return null

  return (
    <Box p={3} data-testid="customer-vehicles-information">
      <Grid container rowSpacing={4}>
        <Grid item xs={12}>
          <Typography variant="h5">Vehicles Information</Typography>
        </Grid>
        <Grid item xs={12}>
          <VehicleGrid autoHeight rows={rows} />
        </Grid>
      </Grid>
    </Box>
  )
}

export default CustomerVehicles
